exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".enums-wrapper[data-v-4754e9eb] {\n  display: flex;\n  align-items: center;\n  min-width: 200px;\n  height: 50px;\n}\n.enums-wrapper .lookup[data-v-4754e9eb] {\n  margin-left: 15px;\n}\n", ""]);

// exports
